import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VToolbar,
                    { attrs: { flat: "" } },
                    [
                      _c(VToolbarTitle, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "title primary--text text--darken-1 text-no-wrap mt-0",
                          },
                          [
                            _vm._v(
                              " INDICAÇÕES DE TALENTOS E DE DESENVOLVIMENTO "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-center" },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "8", md: "8", sm: "12" } },
                    [
                      _c("app-indicacao", {
                        attrs: {
                          "indicacoes-desenvolvimento":
                            _vm.indicacoesDesenvolvimento,
                          "indicacoes-talento": _vm.indicacoesTalento,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VToolbar,
                    { attrs: { flat: "" } },
                    [
                      _c(VToolbarTitle, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "title primary--text text--darken-1 text-no-wrap mt-0",
                          },
                          [_vm._v(" GRÁFICOS ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-center" },
                [
                  _c(
                    VCol,
                    [
                      _c(
                        VRow,
                        { ref: "graficos", staticClass: "justify-center" },
                        [
                          _c("gauge-chart", {
                            staticClass: "chart",
                            attrs: {
                              dados: _vm.gaugeChart,
                              descricao: _vm.descricaoGraficoNotaAgrupada,
                              fonte: `Fonte: Sistema Desenvolva, ${_vm.anoDiagnostico}`,
                              maximo: _vm.desempenho.notaMaxima * 10,
                              minimo: 0,
                              "descricao-titulo":
                                "Resultado do Desempenho Comportamental",
                              formato: "%",
                              titulo: "Resultado do Desempenho Comportamental",
                              "is-get-svg": _vm.isGetSvg,
                            },
                            on: { svg: (value) => (_vm.svg = value) },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-0",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.desempenho.resultadosComportamentais,
                          search: _vm.opcoes.pesquisa,
                          "sort-by": _vm.opcoes.ordenarPor,
                          "sort-desc": _vm.opcoes.decrescente,
                          "disable-pagination": "",
                          "hide-default-footer": "",
                          "show-expand": "",
                          "single-expand": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VRow,
                                    [
                                      _c(
                                        VToolbar,
                                        { attrs: { flat: "" } },
                                        [
                                          _c(VToolbarTitle, [
                                            _c(
                                              "h2",
                                              {
                                                staticClass:
                                                  "title primary--text text--darken-1 text-no-wrap",
                                              },
                                              [_vm._v(" RESULTADOS ")]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("app-sort", {
                                            model: {
                                              value: _vm.opcoes,
                                              callback: function ($$v) {
                                                _vm.opcoes = $$v
                                              },
                                              expression: "opcoes",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(VCol, {
                                        attrs: { cols: "0", md: "4" },
                                      }),
                                      _c(
                                        VCol,
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("app-search", {
                                            model: {
                                              value: _vm.opcoes,
                                              callback: function ($$v) {
                                                _vm.opcoes = $$v
                                              },
                                              expression: "opcoes",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: `item.data-table-expand`,
                              fn: function ({ item, expand, isExpanded }) {
                                return [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        height: "100%",
                                                        text: "",
                                                        width: "100%",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return expand(
                                                            !isExpanded
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VBadge,
                                                      {
                                                        attrs: { right: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "badge",
                                                              fn: function () {
                                                                return [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item
                                                                          .itensResultado
                                                                          .length
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c(
                                                          VIcon,
                                                          {
                                                            attrs: {
                                                              color:
                                                                "grey lighten-0",
                                                              large: "",
                                                            },
                                                          },
                                                          [_vm._v(" thumb_up ")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Clique para exibir os comportamentos"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "expanded-item",
                              fn: function ({ headers, item }) {
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "justify-center",
                                      attrs: { colspan: headers.length },
                                    },
                                    [
                                      _c(
                                        VRow,
                                        { attrs: { dense: "" } },
                                        [
                                          _c(VSpacer),
                                          _c(
                                            VCol,
                                            [
                                              _c(
                                                VRow,
                                                {
                                                  staticClass: "justify-center",
                                                },
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "title primary--text text--darken-1 text-no-wrap",
                                                    },
                                                    [_vm._v(" COMPORTAMENTOS ")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(VSpacer),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VRow,
                                        [
                                          _c(VSpacer),
                                          _c(
                                            VCol,
                                            { attrs: { cols: "10" } },
                                            [
                                              _c(VSimpleTable, {
                                                staticClass: "elevation-0 mb-4",
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function () {
                                                        return [
                                                          _c("thead", [
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "text-left",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " COMPORTAMENTO "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " IMPORTÂNCIA "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " NOTA AUTOAVALIACAO "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm.desempenho
                                                                .chefia &&
                                                              _vm.desempenho
                                                                .equipe &&
                                                              _vm.desempenho
                                                                .notaSubordinados >
                                                                0
                                                                ? _c(
                                                                    "th",
                                                                    {
                                                                      staticClass:
                                                                        "text-center",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " NOTA EQUIPE "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm.desempenho
                                                                .pares
                                                                ? _c(
                                                                    "th",
                                                                    {
                                                                      staticClass:
                                                                        "text-center",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " NOTA EQUIPE "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " NOTA GESTOR "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " NOTA MÁXIMA "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " RESULTADO "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]),
                                                          _c(
                                                            "tbody",
                                                            _vm._l(
                                                              item.itensResultado,
                                                              function (
                                                                itemResultado
                                                              ) {
                                                                return _c(
                                                                  "tr",
                                                                  {
                                                                    key:
                                                                      "item" +
                                                                      itemResultado.id,
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        attrs: {
                                                                          width:
                                                                            "35%",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                itemResultado
                                                                                  .comportamento
                                                                                  .descricao
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "text-center",
                                                                        attrs: {
                                                                          width:
                                                                            "5%",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "decimal"
                                                                                )(
                                                                                  itemResultado
                                                                                    .comportamento
                                                                                    .importancia
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "text-center",
                                                                        attrs: {
                                                                          width:
                                                                            "10%",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "decimal"
                                                                                )(
                                                                                  itemResultado.notaAutoavaliacao
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm
                                                                      .desempenho
                                                                      .chefia &&
                                                                    _vm
                                                                      .desempenho
                                                                      .equipe &&
                                                                    _vm
                                                                      .desempenho
                                                                      .notaSubordinados >
                                                                      0
                                                                      ? _c(
                                                                          "td",
                                                                          {
                                                                            staticClass:
                                                                              "text-center",
                                                                            attrs:
                                                                              {
                                                                                width:
                                                                                  "10%",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "grey--text text--darken-2",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "decimal"
                                                                                    )(
                                                                                      itemResultado.notaSubordinados
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm
                                                                      .desempenho
                                                                      .pares
                                                                      ? _c(
                                                                          "td",
                                                                          {
                                                                            staticClass:
                                                                              "text-center",
                                                                            attrs:
                                                                              {
                                                                                width:
                                                                                  "10%",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "grey--text text--darken-2",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "decimal"
                                                                                    )(
                                                                                      itemResultado.notaPares
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "text-center",
                                                                        attrs: {
                                                                          width:
                                                                            "10%",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "decimal"
                                                                                )(
                                                                                  itemResultado.notaGestor
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "text-center",
                                                                        attrs: {
                                                                          width:
                                                                            "10%",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "decimal"
                                                                                )(
                                                                                  itemResultado.notaMaxima
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "text-center",
                                                                        attrs: {
                                                                          width:
                                                                            "10%",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "decimal"
                                                                                )(
                                                                                  itemResultado.notaAgrupada
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(VSpacer),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.notaAutoavaliacao`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("decimal")(
                                          item.notaAutoavaliacao
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.notaSubordinados`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("decimal")(item.notaSubordinados)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.notaPares`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("decimal")(item.notaPares)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.notaGestor`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("decimal")(item.notaGestor)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.notaMaxima`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("decimal")(item.notaMaxima)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.notaAgrupada`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("decimal")(item.notaAgrupada)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `body.append`,
                              fn: function () {
                                return [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        attrs: {
                                          align: "center",
                                          colspan: "2",
                                        },
                                      },
                                      [
                                        _c(
                                          "strong",
                                          {
                                            staticClass:
                                              "subtitle-2 grey--text text--darken-2",
                                          },
                                          [_vm._v("TOTAL")]
                                        ),
                                      ]
                                    ),
                                    _c("td", { attrs: { align: "center" } }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("decimal")(
                                              _vm.desempenho.notaAutoavaliacao
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm.desempenho.pares &&
                                    _vm.desempenho.notaPares > 0
                                      ? _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("decimal")(
                                                    _vm.desempenho.notaPares
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.desempenho.chefia &&
                                    _vm.desempenho.equipe &&
                                    _vm.desempenho.notaSubordinados > 0
                                      ? _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("decimal")(
                                                    _vm.desempenho
                                                      .notaSubordinados
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("td", { attrs: { align: "center" } }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("decimal")(
                                              _vm.desempenho.notaGestor
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("td", { attrs: { align: "center" } }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("decimal")(
                                              _vm.desempenho.notaMaxima
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("td", { attrs: { align: "center" } }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("decimal")(
                                              _vm.desempenho.notaAgrupada
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _c(VDivider),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "justify-end mb-1" },
        [
          _c(
            VTooltip,
            {
              attrs: { "max-width": "400", top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            staticClass: "mr-4",
                            attrs: { color: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.getRelatorio(_vm.desempenho)
                              },
                            },
                          },
                          on
                        ),
                        [
                          _c(VIcon, [_vm._v("get_app")]),
                          _vm._v(" BAIXAR PDF "),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("span", [
                _vm._v(
                  "Clique para baixar o relatório dos dados em formato PDF."
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }